export const abacusConfig = {
  enablePersistentFilters: false,
  flashMessageTimeout: 5000
}
